import React from 'react';
import '../styles/Templates.css';

const Templates = () => {
  return (
    <section className="templates">
      <div className="container">
        <div className="templates-content">
          <div className="templates-image">
            <img 
              src="/images/contract-v2.png" 
              alt="Contract template" 
              className="document-illustration"
              draggable="false"
            />
          </div>
          
          <div className="templates-text">
            <h2>Contract templates for freelancers, startups, and small businesses, crafted to protect your work, your clients, and your bottom line.</h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Templates;
